module.exports = __webpack_public_path__ + "img/tele-banner.db99bf89.png";